var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.content === true)?_c('span',[_vm._v("IN")]):(_vm.content === false)?_c('span',[_vm._v("OUT")]):_c('span',[_vm._v("C2C")])])
}
var staticRenderFns = []

export { render, staticRenderFns }